<template>
  <v-alert
    v-if="showAlertActivateTwoStepsAuthentication"
    class="py-0 mt-4"
    :class="{
      'mx-5': $vuetify.breakpoint.smAndDown,
    }"
    type="warning"
    border="left"
    :icon="false"
    dismissible
    dense
  >
    <div
      class="py-2 black--text"
      :class="{
        'caption font-weight-bold': $vuetify.breakpoint.smAndDown,
      }"
      style="cursor: pointer;"
      @click="
        $router.push({
          name: 'Perfil',
          query: {
            tabProfile: 'security',
          },
        })
      "
    >
      {{ $t("verifySmsToken.recommendActivateTwoStepsAuthentication") }}
    </div>

    <template v-slot:close>
      <v-btn
        small
        icon
        color="black"
        @click="closeAlertActivateTwoStepsAuthentication"
      >
        <v-icon color="black" size="24">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-alert>
</template>

<script>
export default {
  name: "AlertActivateTwoStepsAuthentication",

  data: () => ({
    alertActivateTwoStepsAuthAlreadyClosed: false,
  }),

  mounted() {
    this.verifyAlertActivateTwoStepsAuthAlreadyClosed();
  },

  watch: {
    "$store.state.logged.status"() {
      this.verifyAlertActivateTwoStepsAuthAlreadyClosed();
    },
  },

  computed: {
    showAlertActivateTwoStepsAuthentication() {
      const isCasinoMainPage =
        this.$store.state.operators.home_page === "casino";

      const sportPossiblePages = ["bigTable", "Sports"];

      const homePageByPreferenceOperator =
        (this.$route.name === "casinoLobby" && isCasinoMainPage) ||
        (sportPossiblePages.includes(this.$route.name) && !isCasinoMainPage);

      if (
        this.$store.state.logged.status &&
        !this.alertActivateTwoStepsAuthAlreadyClosed &&
        homePageByPreferenceOperator
      )
        return true;

      return false;
    },
  },

  methods: {
    verifyAlertActivateTwoStepsAuthAlreadyClosed() {
      const alertActivateTwoStepsAuthentication = JSON.parse(
        localStorage.getItem("alertActivateTwoStepsAuthentication")
      );

      this.alertActivateTwoStepsAuthAlreadyClosed = alertActivateTwoStepsAuthentication
        ? true
        : false;
    },
    closeAlertActivateTwoStepsAuthentication() {
      localStorage.setItem("alertActivateTwoStepsAuthentication", true);

      this.alertActivateTwoStepsAuthAlreadyClosed = true;
    },
  },
};
</script>
